export const checkQuantity = (quantity) => {
	if (quantity === 1) {
		return true;
	}
	return false;
};
